import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SwapOfferCard from "./SwapOfferCard";
import { API_BASE_URL } from "../config";


function MySwapOffers() {
  const user = JSON.parse(localStorage.getItem("user")) || null;
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

 useEffect(() => {
  if (!user?.id) {
    setLoading(false);
    return;
  }

  const fetchOffers = async () => {
    try {
      const token = localStorage.getItem("token");

      const [mowingRes, cleaningRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/swaps/sent/${user.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
        fetch(`${API_BASE_URL}/api/cleaning/swaps/sent/${user.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);

      const mowingData = await mowingRes.json();
      const cleaningData = await cleaningRes.json();

      const mergedOffers = [
        ...(mowingData.offers || []),
        ...(cleaningData.offers || []),
      ];

      setOffers(mergedOffers);
    } catch (err) {
      console.error("❌ Failed to load swap offers:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchOffers();
}, [user?.id]);


  return (
    <div style={{ padding: "20px" }}>
      
      {/* BACK BUTTON */}
      <button
        onClick={() => navigate(-1)}
        style={{
          padding: "8px 14px",
          backgroundColor: "#2e7d32",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          marginBottom: "15px",
        }}
      >
        ← Back
      </button>

      <h2>My Swap Offers</h2>

      {loading ? (
        <p>Loading your swap offers...</p>
      ) : offers.length === 0 ? (
        <p>You have not sent any swap offers yet.</p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "20px",
            marginTop: "20px",
          }}
        >
          {offers.map((offer) => (
            <SwapOfferCard
              key={offer.id || offer.requestId}
              offer={offer}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default MySwapOffers;
